import { render, staticRenderFns } from "./DuplicateCleanDrawer.vue?vue&type=template&id=499d8a18&scoped=true"
import script from "./DuplicateCleanDrawer.vue?vue&type=script&lang=js"
export * from "./DuplicateCleanDrawer.vue?vue&type=script&lang=js"
import style0 from "./DuplicateCleanDrawer.vue?vue&type=style&index=0&id=499d8a18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499d8a18",
  null
  
)

export default component.exports